import { DEFAULT_MAX_SIZE } from "@tfg/ui"
import { AxiosError } from "axios"
import { useTranslation } from "react-i18next"

import { queryClient } from "~/backend/queryClient"
import { FindIngestionsFiltersDto, findIngestionsQueryKey } from "~/gen/api"
import { ImportDocumentCard } from "~/pages/Brand/DataTransfer/Import/components/ImportDocumentCard"
import { IngestionSortsType } from "~/pages/Brand/DataTransfer/Import/components/IngestionsSorts"
import { useBatchCreateSuppliersMutation } from "~/pages/Brand/DataTransfer/Import/hooks/useBatchCreateSuppliersMutation"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

type BusinessPartnerImportCardProps = {
  sorts: IngestionSortsType
  filters: FindIngestionsFiltersDto
}

export const BusinessPartnerImportCard = ({
  sorts,
  filters,
}: BusinessPartnerImportCardProps) => {
  const { t } = useTranslation("dataTransfer")

  const { mutate: batchCreateSuppliers } = useBatchCreateSuppliersMutation({
    onError: (error: AxiosError) => {
      showAxiosError({
        notificationTitle: t("upload.error"),
        notificationMessage: error.message,
        showNotification: true,
        error,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: findIngestionsQueryKey({ sorts, filters }),
      })
      showSuccessNotification({
        title: t("upload.success"),
        message: t("upload.success"),
      })
    },
  })

  return (
    <ImportDocumentCard
      title={t("import.businessPartner.templateCard.title")}
      description={t("import.businessPartner.templateCard.description")}
      uploadButtonProps={{
        tooltip: t("import.businessPartner.templateCard.uploadButton.tooltip", {
          maxSize: DEFAULT_MAX_SIZE / 1024 ** 2,
        }),
        label: t("import.businessPartner.templateCard.uploadButton.label"),
      }}
      notificationsProps={{
        erase: t("upload.erase"),
      }}
      areYouSureModalProps={{
        areYouSureText: t("upload.info"),
      }}
      uploadAction={batchCreateSuppliers}
    />
  )
}
